/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuFilters_filters = ReadonlyArray<{
    readonly name: string | null;
    readonly totalCount: number | null;
    readonly localizedFilterName: string | null;
    readonly values: ReadonlyArray<{
        readonly displayName: string | null;
        readonly urlLabel: string | null;
        readonly count: number | null;
        readonly code: string | null;
        readonly linkReference: string | null;
        readonly linkable: boolean | null;
        readonly hexCode: string | null;
        readonly stats: ReadonlyArray<{
            readonly key: string | null;
            readonly values: string | null;
        } | null> | null;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuFilterCategory_filters" | "SbMobileRefineMenuFilterCategory_filters" | "SbRespRefineMenuFilterDimensions_filters" | "SbMobileRefineMenuFilterDimensions_filters">;
    readonly " $refType": "SbSharedRefineMenuFilters_filters";
}>;
export type SbSharedRefineMenuFilters_filters$data = SbSharedRefineMenuFilters_filters;
export type SbSharedRefineMenuFilters_filters$key = ReadonlyArray<{
    readonly " $data"?: SbSharedRefineMenuFilters_filters$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilters_filters">;
}>;



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilters_filters",
  "type": "SearchBrowseFilter",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "totalCount",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "localizedFilterName",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "values",
      "storageKey": null,
      "args": null,
      "concreteType": "SearchBrowseFilterValue",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "displayName",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "urlLabel",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "count",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "code",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "linkReference",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "linkable",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "hexCode",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "stats",
          "storageKey": null,
          "args": null,
          "concreteType": "stats",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "key",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "values",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterCategory_filters",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterCategory_filters",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterDimensions_filters",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterDimensions_filters",
      "args": null
    }
  ]
};
(node as any).hash = '2a6463a750bcfbf7e5ff695d33d62f0e';
export default node;
